import { render, staticRenderFns } from "./orderDetailShow.vue?vue&type=template&id=a7270328&scoped=true"
import script from "./orderDetailShow.vue?vue&type=script&lang=js"
export * from "./orderDetailShow.vue?vue&type=script&lang=js"
import style0 from "./orderDetailShow.vue?vue&type=style&index=0&id=a7270328&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7270328",
  null
  
)

export default component.exports